export const state = {
  regulation: {}
}

export default state



// WEBPACK FOOTER //
// ./src/store/module/regulation/state.js